import React from "react";
import { connect } from "react-redux";
import { selectIndustry } from "../../actions/";
import SVG from "react-inlinesvg";

import WizardStep from "../WizardStep";
import WizardSidebar from "../WizardSidebar";
import industryList from "../../config/industryList";
import "../../css/Industry.scss";

class Industry extends React.Component {
	state = {
		title: "What do you sell?",
		text:
			"Your industry will help us understand which program is right for you.",
		disabledButton: "disabled",
		industryList: industryList,
		isSafari: false
	};

	componentDidMount = () => {
		const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
		this.setState({
			isSafari
		});
	};

	industrySelected = industry => {
		this.props.selectIndustry(industry);
	};

	renderIndustryList = () => {
		return this.state.industryList.map(industry => {
			return (
				<div
					className={`single-industry ${industry.name} ${
						this.props.industrySelected === industry.name
							? "active"
							: "not-active"
					}`}
					key={industry.name}
					onClick={() => this.industrySelected(industry.name)}>
					{this.generateIndustryImage(industry)}
					<div className="industry-name">{industry.title}</div>
				</div>
			);
		});
	};

	generateIndustryImage = industry => {
		if (!this.state.isSafari) {
			return (
				<div className="industry-illustrations">
					<div className="illustration line">
						<SVG src={industry.svgLine} />
					</div>
					<div className="illustration full">
						<SVG src={industry.svgFull} />
					</div>
				</div>
			);
		} else {
			return (
				<div className="industry-illustrations">
					<div className="illustration line">
						<img src={industry.svgLine} alt={industry.name} />
					</div>
					<div className="illustration full safari">
						<img src={industry.svgFull} alt={industry.name} />
					</div>
				</div>
			);
		}
	};

	render() {
		return (
			<div className="view industry">
				<WizardSidebar
					title="LOYALTY & REFERRALS PROGRAMS ARE NO LONGER JUST “NICE TO HAVE”"
					text={
						<div>
							<p>
								No matter your industry, Loyalty & Referrals programs are an essential investment for your brand.
							</p>
							<p>
								In a world where brands can no longer compete on price and functionality alone, a Loyalty & Referrals program is a powerful tool for furthering your business and future-proofing your brand.
							</p>
						</div>
					}
					image="step-1"
				/>
				<WizardStep
					title={this.state.title}
					text={this.state.text}
					navigateTo="design"
					buttonText="Next"
					actionType="Industry"
					disabledButton={this.props.industrySelected ? "" : "disabled"}>
					{this.renderIndustryList()}
				</WizardStep>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		industrySelected: state.industry
	};
};

export default connect(
	mapStateToProps,
	{ selectIndustry }
)(Industry);
